import axios from '@/http/index';

const base = '';
export default {
  // 获取新增会员的链接地址
  getSignSuccess(params) {
    return axios.get(`${base}/erp/login/loginSuccess`, params).then((res) => res.data);
  },
  // (产品销售)获得产品出库统计数据
  getErpProductOutPutMsg(params) {
    return axios.get(`${base}/erp/statistics/getErpProductOutPutMsg`, params).then((res) => res.data);
  },
  // (员工业绩 )员工业绩查询
  getEmployeePerformance(params) {
    return axios.get(`${base}/erp/statistics/getEmployeePerformance`, params).then((res) => res.data);
  },
  // (营业收入)获得门店营业收入列表信息
  getYysr(params) {
    return axios.get(`${base}/erp/statistics/getStoreIncomeList`, params).then((res) => res.data);
  },
  // (营业收入)获得门店营业收入统计信息
  getYysrTotal(params) {
    return axios.get(`${base}/erp/statistics/getStoreIncomeMsg`, params).then((res) => res.data);
  },
  // 总还款记录列表
  getZhkjl(params) {
    return axios.get(`${base}/erp/account/toAccountRefundItem`, params).then((res) => res.data);
  },
  // 员工业绩列表
  getYgyj(params) {
    return axios.get(`${base}/erp/statistics/toEmployeePerformance`, params).then((res) => res.data);
  },
  // 员工业绩列表--详情--没有用到的接口
  getYgyjDetails(params) {
    return axios.get(`${base}/erp/statistics/toOneEmployeePerformance`, params).then((res) => res.data);
  },
  // 消费统计--数据
  getXftjOne(params) {
    return axios.get(`${base}/erp/statistics/getConsumptionStatistics`, params).then((res) => res.data);
  },
  // 消费统计--图表
  getXftjTwo(params) {
    return axios.get(`${base}/erp/statistics/getProjectIncome`, params).then((res) => res.data);
  },
  // 产品销售--图表
  getSpxs(params) {
    return axios.get(`${base}/erp/statistics/getProductIncome`, params).then((res) => res.data);
  },
  // 获得会员套餐客户信息
  getUserCardInfo(params) {
    return axios.get(`${base}/erp/lookVipCard/selectClientVipCardInfo`, params).then((res) => res.data);
  },
  // 查看会员套餐
  getSelectCard(params) {
    return axios.get(`${base}/erp/lookVipCard/selectClientVipCardList`, params).then((res) => res.data);
  },
  // 修改会员套餐
  postEditCard(params) {
    return axios.post(`${base}/erp/lookVipCard/updateClientVipCardItemInfo`, params).then((res) => res.data);
  },
  // 获取会员套餐开单员列表
  getStaffIdList(params) {
    return axios.get(`${base}/erp/lookVipCard/technicianList`, params).then((res) => res.data);
  },
  // 根据会员套餐ID获得提成信息
  getIdSelectCard(params) {
    return axios.get(`${base}/erp/lookVipCard/selectVipCardPercentage`, params).then((res) => res.data);
  },
  // 会员套餐购买--选择扫码支付
  postGainQRCode(params) {
    return axios.post(`${base}/erp/lookVipCard/gouGainQRCode`, params).then((res) => res.data);
  },
  // 会员套餐充值--选择扫码支付
  postPurchaseGainQRCode(params) {
    return axios.post(`${base}/erp/lookVipCard/purchaseGainQRCode`, params).then((res) => res.data);
  },
  // 检测扫码支付的状态
  getPaymentStatus(params) {
    return axios.get(`${base}/erp/lookVipCard/paymentType`, params).then((res) => res.data);
  },
  // 会员套餐购买--确定支付
  postCardShopping(params) {
    return axios.post(`${base}/erp/lookVipCard/gouClientVipCard`, params).then((res) => res.data);
  },
  // 会员套餐充值--确定支付
  postCardPurchase(params) {
    return axios.post(`${base}/erp/lookVipCard/purchaseClientVipCard`, params).then((res) => res.data);
  },
  /// /会员套餐划扣--选择扫码支付
  postDeductCardCount(params) {
    return axios.post(`${base}/erp/lookVipCard/updateClientVipCardItem`, params).then((res) => res.data);
  },
  // 查询会员套餐和项目信息(购买+划扣+充值)
  selectVipCardItemList(params) {
    return axios.get(`${base}/erp/lookVipCard/selectVipCardItemList`, params).then((res) => res.data);
  },
  // 赊账列表
  getGzlb(params) {
    return axios.get(`${base}/erp/account/getAccountList`, params).then((res) => res.data);
  },
  // 当班记录列表
  getDbjl(params) {
    return axios.get(`${base}/erp/cashBox/getIncomeDetail4Day`, params).then((res) => res.data);
  },
  // 当班记录--钱箱提现记录列表
  getQxtx(params) {
    return axios.get(`${base}/erp/cashBox/getIncomeDetailItem`, params).then((res) => res.data);
  },
  // 获取 当月工资/上月工资
  getDygzOrSygz(params) {
    return axios.get(`${base}/erp/lookSalarySubsidyDeduct/selectSalaryList`, params).then((res) => res.data);
  },
  // 获取 扣款/补助/奖金
  getJjkkbzData(params) {
    return axios.get(`${base}/erp/lookSalarySubsidyDeduct/selectSubsidyDeductList`, params).then((res) => res.data);
  },
  /// /添加 扣款/补助/奖金
  postAddJjkkbzData(params) {
    return axios.post(`${base}/erp/lookSalarySubsidyDeduct/insertSubsidyDeduct`, params).then((res) => res.data);
  },
  // 获取 扣款/补助/奖金
  getDelJjkkbzData(params) {
    return axios.get(`${base}/erp/lookSalarySubsidyDeduct/deleteSubsidyDeduct`, params).then((res) => res.data);
  },
  // 获取 项目收入- 分类汇总页面
  getItemIncome(params) {
    return axios.get(`${base}/erp/income/getItemIncome`, params).then((res) => res.data);
  },
  // 获取 项目收入-项目汇总页面
  getItemPool(params) {
    return axios.get(`${base}/erp/income/getItemPool`, params).then((res) => res.data);
  },
  // 获取 产品收入页面
  getProductIncome(params) {
    return axios.get(`${base}/erp/income/getProductIncome`, params).then((res) => res.data);
  },
  // 获取 套餐收入页面
  getVipCardIncome(params) {
    return axios.get(`${base}/erp/income/getVipCardIncome`, params).then((res) => res.data);
  },
  // 获取 快捷收入页面
  getFastIncome(params) {
    return axios.get(`${base}/erp/income/getFastIncome`, params).then((res) => res.data);
  },
  // 获取 营业概况头部数据
  getBusiness(params) {
    return axios.get(`${base}/erp/count/getBusiness`, params).then((res) => res.data);
  },
  // 获取 收入明细列表
  getIncomeDetail(params) {
    return axios.get(`${base}/erp/count/getIncomeDetail`, params).then((res) => res.data);
  },
  // 获取 收入明细列表详情
  getIncomeData(params) {
    return axios.get(`${base}/erp/count/getIncomeData`, params).then((res) => res.data);
  },
  // 获取 优惠明细列表
  getDiscoutDtails(params) {
    return axios.get(`${base}/erp/count/getDiscoutDtails`, params).then((res) => res.data);
  },
  // 获取 优惠明细列表详情
  getDiscountData(params) {
    return axios.get(`${base}/erp/count/getDiscountData`, params).then((res) => res.data);
  },
  // 获取 划扣金额明细列表
  getDeductDtails(params) {
    return axios.get(`${base}/erp/count/getDeductDtails`, params).then((res) => res.data);
  },
  // 获取 划扣金额明细列表详情
  getDeductData(params) {
    return axios.get(`${base}/erp/count/getDeductData`, params).then((res) => res.data);
  },
  // 获取 应收欠款明细列表
  getDebtDtails(params) {
    return axios.get(`${base}/erp/count/getDebtDtails`, params).then((res) => res.data);
  },
  // 获取 应收欠款明细列表详情
  getDebtData(params) {
    return axios.get(`${base}/erp/count/getDebtData`, params).then((res) => res.data);
  },
  // 获取 项目汇总详情页面
  getItemDetails(params) {
    return axios.get(`${base}/erp/income/getItemDetails`, params).then((res) => res.data);
  },
  // 获取 产品收入详情页面
  getProductDtails(params) {
    return axios.get(`${base}/erp/income/getProductDtails`, params).then((res) => res.data);
  },
  // 获取 套餐收入详情页面
  getVipCardDetails(params) {
    return axios.get(`${base}/erp/income/getVipCardDetails`, params).then((res) => res.data);
  },
  // (5.2) 营业概况支付数据
  getIncomeInfo(params) {
    return axios.get(`${base}/erp/count/getIncomeInfo`, params).then((res) => res.data);
  },
  // (5.2) 支付明细表头
  getPayDetailsTitle(params) {
    return axios.get(`${base}/erp/count/getPayDetailsTitle`, params).then((res) => res.data);
  },
  // (5.2) 支付明细
  getPayDetails(params) {
    return axios.get(`${base}/erp/count/getPayDetails`, params).then((res) => res.data);
  },
  // (5.2) 支付明细详情
  getIncomeDetails(params) {
    return axios.get(`${base}/erp/count/getIncomeDetails`, params).then((res) => res.data);
  },
  // (5.2) 退款明细
  getRefundDtails(params) {
    return axios.get(`${base}/erp/count/getRefundDtails`, params).then((res) => res.data);
  },
  // (5.2) 2退款明细详情
  getRefundAnalyse(params) {
    return axios.get(`${base}/erp/count/getRefundAnalyse`, params).then((res) => res.data);
  },

};
